<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Add Allowance</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">
  <form [formGroup]="newAllowanceDetails" autocomplete="off">

    <div class="mb-3">
      <label class="form-label fw-semibold">Description</label>
      <input type="text" class="form-control" formControlName="description">
    </div>

    <div class="mb-3">
      <label class="form-label fw-semibold">Amount</label>
      <div class="input-group">
        <span class="input-group-text">£</span>
        <input class="form-control" formControlName="amount" type="number">
      </div>
    </div>

  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-success"
    [disabled]="newAllowanceDetails.invalid"
    (click)="addAllowance()">Add</button>
</div>